import React from 'react';
import { Box, Button, Stack, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { SquareImage } from 'features/companies/components/SquareImage';
import { BannerImage } from 'features/companies/components';
import { paths } from 'routes';
import { useLocale } from 'i18n/useLocale';

const getFirstSentences = (text, sentenceCount = 3) => {
  if (!text || typeof text !== 'string') {
    return '';
  }
  const sentenceRegex = /.+?[.?!]\s*/g;
  const sentences = text.match(sentenceRegex);
  if (!sentences) {
    return text;
  }

  return sentences.slice(0, sentenceCount).join('').trim();
};

export const CompanyProfile = ({
  company_name,
  square_logo_url = '',
  banner_logo_url = '',
  description = '',
  slug = '',
  company_id = null,
  company_type = 'buyer',
  sx= {},
}) => {
  const lang = useLocale();

  if (company_name.length === 0 || description.length === 0 || square_logo_url.length === 0 || banner_logo_url.length === 0) {
    return null;
  }

  return (
    <Stack
      direction={"column"}
      gap={2}
      sx={{
        border: "1px solid",
        borderRadius: 1,
        borderColor: "border.jobAd",
        p: 1,
        ...sx
      }}
    >
      <Link
      component={RouterLink}
      to={slug ? paths.public.companyPublicProfile(company_type, slug, lang) : paths.buyersDetailsView(company_id)}
      color="inherit"
      underline="none"
    >
      <Stack>
        <BannerImage
          banner={banner_logo_url}
          sx={{
            width: "100%",
            minHeight: "unset",
            maxHeight: "91px",
            border: "1px solid",
            borderRadius: 1,
            borderColor: "border.jobAd"
          }}
          pointer
        />
        <Stack direction="row">
          <SquareImage
            image={square_logo_url}
            wrapperSx={{
              ml:{xs: 1, md: 1, lg: 2, xl: 3},
              width:{xs: 30, sm: 40, md: 50, lg: 75, xl: 100},
              height:{xs: 30, sm: 40, md: 50, lg: 75, xl: 100},
            }}
            sx={{
              width:{xs: 30, sm: 40, md: 50, lg: 75, xl: 100},
              height:{xs: 30, sm: 40, md: 50, lg: 75, xl: 100},
              bottom: "50%",
            }}
          
          />
          <Stack flex={1} direction={"row"}>
            <Box
              px={4}
              height={70}
              sx={{
                justifyContent: 'space-between',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Stack position="relative" flexDirection="column" bottom={"15%"}>
                <Stack position="relative" flexDirection="row" gap={1}>
                  <Typography
                    variant='h3'
                    fontWeight={600}
                    color='text.black'
                    lineHeight={"normal"}
                    letterSpacing={"normal"}
                    fontSize={{xs: '1.125rem', md: "1.25rem"}}
                  >
                    {company_name}
                  </Typography>
                </Stack>
              </Stack>
            </Box>
          </Stack>
        </Stack>
      </Stack>
      <Stack
        gap={2.5}
        marginTop={{xs: "-6%", md: "-5%"/* , lg: "-5%" */}}
      >
        {/* <Typography variant='h5' fontWeight={600} color='text.black' lineHeight={"normal"} letterSpacing={"normal"}>
          {company_name}
        </Typography> */}
        <Typography
          variant='body4'
          fontWeight={400}
          color='text.black'
          letterSpacing={"normal"}
          sx={{
            fontFeatureSettings: `'liga' off, 'clig' off`,
            display: '-webkit-box',
            overflow: 'hidden',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 4,
          }}
        >
          {getFirstSentences(description)}
        </Typography>
      </Stack>
      </Link>
    </Stack>
  );
}